import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import CV from '../../assets/docs/maw-cv.pdf'

function About({title, content}) {
    return(
        <article id="about" className="about">
            <h2 data-aos="fade-up" className="title">{title}</h2>

            <div className="content">
                <p data-aos="fade-up" className="text">{content}</p>
                <p data-aos="fade-up" className="text2"><a class="btn btn-secondary" href={CV}>Descargar CV</a></p>
            </div>
        </article>
    )
}

About.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string
}

About.defaultProps = {
    title: 'No se encontró titulo',
    content: 'No se encontró contenido'
}

export default About;